export const CONVERSIONS_GET_ALL = 'CONVERSIONS_GET_ALL';
export const CONVERSIONS_GET_FAILURE = 'CONVERSIONS_GET_FAILURE';
export const CONVERSIONS_DATA_IS_LOADING = 'CONVERSIONS_DATA_IS_LOADING';
